<!-- Colored top bar — matches pages.component pattern -->
<hr class="line du-page-line-desktop" [ngStyle]="{ background: newColor }" />

<!-- Scrollable page body (topnav lives inside, matching pages.component) -->
<div style="flex: 1 0 auto" class="overFlowForPage">

  <!-- Top navigation — matches pages.component pattern. The title comes from
       navbar_page_nm (set by DashboardComponent.openPage), like every other
       page, rather than a hardcoded [pagename]. -->
  <app-topnav [clientLogo]="clientLogo"></app-topnav>

  <!-- Filter chips row. Mirrors the real app-filter-badges widget, but reads
       EmdFilterService rather than FilterService.badges, which this standalone
       prototype does not populate. Applying a badge re-derives the active tab
       from the 852/867 fact tables. -->
  <emd-filter-bar
    [chips]="activeChips"
    [dateRange]="activeDateRange"
    [showFilterButton]="activeTab === 'Summary'"
    [accentColor]="accentColor"
    (chipChange)="onChipChange()"
    (dateRangeChange)="onDateRangeChange($event)"
    (filterClick)="filterPanelOpen = true"
    (reset)="onResetFilters()"
  ></emd-filter-bar>

  <!-- Right slide-in filter panel: a roomier alternate UI over the same filter
       state as the chip strip. Opened by its own sticky handle or the bar's
       funnel button; shares EmdFilterService via the shell handlers. -->
  <emd-filter-panel
    [chips]="activeChips"
    [dateRange]="activeDateRange"
    [accentColor]="accentColor"
    [(open)]="filterPanelOpen"
    (chipChange)="onChipChange()"
    (dateRangeChange)="onDateRangeChange($event)"
    (reset)="onResetFilters()"
  ></emd-filter-panel>

  <!-- Tab strip: segmented pills + the per-tab range controls on the right -->
  <div class="emd-tabbar">
    <emd-pill-group
      [options]="tabs"
      [value]="activeTab"
      size="lg"
      ariaLabel="Dashboard view"
      (valueChange)="onTabChange($event)"
    ></emd-pill-group>

    <div class="emd-tabbar-controls">
      <emd-pill-group
        *ngIf="activeTab === 'Details'"
        [options]="timeBuckets"
        [value]="detailsBucket"
        (valueChange)="onDetailsBucketChange($event)"
        ariaLabel="Time bucket"
      ></emd-pill-group>

      <ng-container *ngIf="activeTab === 'Inventory'">
        <emd-pill-group
          [options]="dohModes"
          [(value)]="inventoryDohMode"
          ariaLabel="Days or weeks on hand"
        ></emd-pill-group>
        <emd-pill-group
          [options]="dayModes"
          [(value)]="inventoryDayMode"
          ariaLabel="Daily or weekly"
        ></emd-pill-group>
      </ng-container>
    </div>
  </div>

  <!-- Only the active tab is instantiated, so each tab's charts render against
       a laid-out container rather than a hidden zero-size one. -->
  <div class="emd-tab-body" [ngSwitch]="activeTab">
    <emd-summary-tab *ngSwitchCase="'Summary'"></emd-summary-tab>
    <emd-details-tab *ngSwitchCase="'Details'" [bucket]="detailsBucket"></emd-details-tab>
    <emd-inventory-tab *ngSwitchCase="'Inventory'"></emd-inventory-tab>
  </div>

</div><!-- /overFlowForPage -->

<!-- The Qlik-style confirm/cancel bar now lives in each widget's own header
     (emd-widget-header selectionOrigin), not as a global overlay here. -->

<!-- Floating messenger — matches pages.component pattern -->
<app-messenger></app-messenger>
